import { generateGUID } from "../../../utils/guid.js";
import { actions } from "../slice.js";
import { thunkTypes } from "../thunk-types.js";
import { createAsyncThunk } from "@reduxjs/toolkit";
//#region src/redux/modal-view/thunks/reveal-modal-view.ts
var revealModalView = createAsyncThunk(thunkTypes.REVEAL_MODAL_VIEW, async (param, { dispatch }) => {
	const modalView = {
		...param,
		id: generateGUID(),
		isVisible: false
	};
	dispatch(actions.updateModalView(modalView));
	setTimeout(() => {
		dispatch(actions.updateModalView({
			id: modalView.id,
			isVisible: true
		}));
	}, 50);
	return modalView;
});
//#endregion
export { revealModalView };

//# sourceMappingURL=reveal-modal-view.js.map